import { Avatar, Box, Typography } from "@mui/material"
import { FC } from "react"
import AvatarFallback from "../../../assets/svg/header-icons-pack/avatar-empty-icon.svg?react"
import Pencil from "../../../assets/svg/promotion-icon/pencil"
import * as st from "./style"

export type EmployeeCardInfoProps = {
  id: number
  firstname: string
  lastname: string
  avatar_url: string
  username: string
  handleDeleteUser: (id: number) => void
}
export const EmployeeCardInfo: FC<EmployeeCardInfoProps> = ({
  username,
  id,
  lastname,
  firstname,
  avatar_url,
  handleDeleteUser,
}) => {
  return (
    <Box onClick={() => {}} sx={st.employeeCard}>
      <Box sx={st.employeeCardCont}>
        <Avatar
          src={avatar_url}
          alt={username || "avatar"}
          sx={st.employeeCardAvatar}
        >
          <AvatarFallback />
        </Avatar>
        <Box sx={st.employeeCardInfo}>
          {username && (
            <Typography
              variant="body1"
              fontWeight={500}
              color={"var(--primary-text)"}
            >
              {`@${username}`}
            </Typography>
          )}
          <Typography
            variant="body1"
            fontWeight={500}
            color={"var(--primary-text)"}
            textTransform="capitalize"
          >
            {firstname && firstname} {lastname && lastname}
            {!username && !firstname && !lastname ? "unknown" : ""}
          </Typography>
        </Box>
      </Box>

      <Box onClick={() => handleDeleteUser(id)} sx={st.employeeCardAction}>
        <Pencil color="var(--Schemes-Primary)" />

        <Typography
          variant="caption"
          color={"var(--Schemes-Primary)"}
          fontWeight={400}
          textTransform="uppercase"
        >
          Разжаловать
        </Typography>
      </Box>
    </Box>
  )
}
